import * as _ from 'lodash';
import React, { useState, useEffect, useContext, useRef } from 'react';
import useFetch from 'use-http';
// import State from 'src/models/State';
import Project from 'src/models/Project';
import PBNavBar from '../PBNavBar';
import { useForm } from 'react-hook-form';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { UserRoles } from 'src/models/UserRole';
import DialogList from 'src/dialogs';
import ExcelFileDialog from '../dialogs/ExcelFileDialog';
import RefreshDataDialog from '../dialogs/RefreshDataDialog';
import CollapsibleSection from 'src/components/common/CollapsibleSection';
// import Expense from 'src/models/AP/Expense';
import PayPeriod from 'src/models/AP/PayPeriod';
import Form from 'src/components/controls/forms/Form';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import FormLabel from 'src/components/controls/forms/FormLabel';
import { BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaCheckCircle, FaFlag, FaUndo, FaPenSquare } from 'react-icons/fa';
import { ODataFilter, ODataOptions, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import ReportOptionsDialog from 'src/components/accounts-payable/dialogs/ReportOptionsDialog';
import { ITableConfig } from 'src/components/common/table';
import FindManagerDialog from '../dialogs/FindManagerDialog';
import Landman from 'src/models/Landman';
import BillingApproval from 'src/models/AP/BillingApproval';
import TimeAndExpense from 'src/models/AP/TimeAndExpense';
import LandmanExpense from 'src/models/AP/LandmanExpense';
import PersonnelSummaryDialog from 'src/components/client-project/dialogs/PersonnelSummaryDialog';
import ClientBillingInfo from 'src/models/ClientBillingInfo';
import ClientProjectSearch from '../components/ClientProjectSearch';
import FlagNoteDialog from '../dialogs/FlagNoteDialog';
import ViewLandmanExpensesDialog from '../dialogs/ViewExpensesDialog';
import FlagNote from 'src/models/AP/FlagNote';
import ViewFlagNotesDialog from '../dialogs/ViewFlagNotesDialog';
import TsdiClient from 'src/models/AP/Client';
import BillingSummaryReport from 'src/models/AP/BillingSummaryReport';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import TsdiBillingWorkDescriptions from 'src/models/AP/LandmanWorkDescriptions';
import { AnyObject } from 'final-form';
import '../css/ProjectBilling.scss';
// import { SelectItem } from 'src/models/common/SelectItem';

const ProjectBillingPage = () => {
    const appContext = useContext<IAppContextState>(AppContext);
    const isAccountingAdmin = appContext.currentUser.role === UserRoles.Admin; // .AccountingAdmin;
    const dispatch = useDispatch();
    // const { get, post, del, put, response } = useFetch();
    const { get, put, post, response } = useFetch();
    // const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const { register, handleSubmit, errors, reset, setValue, getValues } = useForm();
    const { post: postBinary, response: responseBinary } = useFetch('/v1.0', {
            responseType: 'arrayBuffer' // only applies to this instance
          });
    const {
        register: registerBillingApprovalsForm,
        handleSubmit: handleSubmitBillingApprovalsForm,
        reset: resetBillingApprovalsForm
      } = useForm();
    const [managers, setManagers] = useState<Landman[]>(undefined);
    const [workDescriptionLandmen, setWorkDescriptionLandmen] = useState<Array<number>>(undefined);
    const [landmanWorkDescriptions, setLandmanWorkDescriptions] = useState<Array<TsdiBillingWorkDescriptions>>(undefined);
    const [clientBillingInfo, setClientBillingInfo] = useState<ClientBillingInfo>(undefined);
    const [projects, setProjects] = useState<Project[]>(undefined);
    // const [timeAndExpenses, setTimeAndExpenses] = useState<Array<Expense>>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<PayPeriod>>(undefined);
    const [flagAndCorrectionNoteSearchOptions, setFlagAndCorrectionNoteSearchOptions] = useState<ODataOptions>(undefined);
    const [payPeriodSearchOptions, setPayPeriodSearchOptions] = useState<ODataOptions>(undefined);
    const [dlcOffices, setDlcOffices] = useState<Array<{value: number | string, label: string}>>(undefined);
    const [showPreviousBilling, setShowPreviousBilling] = useState<boolean>(false);
    const [showViewFlagNotes, setShowViewFlagNotes] = useState<boolean>(false);
    const [generating, setGenerating] = useState<boolean>(false);
    const [noteMode, setNoteMode] = useState<boolean>(false);
    const [billingTotal, setBillingTotal] = useState<number>(undefined);
    const [billingApprovalsRendered, setBillingApprovalsRendered] = useState<boolean>(false);
    const [showBilledServices, setShowBilledServices] = useState<boolean>(true);
    const [payPeriodSearchTerm, setPayPeriodSearchTerm] = useState<string>('');
    const [fetchNextPayPeriodsPage, setFetchNextPayPeriodsPage] = useState<boolean>(true);
    const [selectedManager, setSelectedManager] = useState<string>(undefined);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [restoreSelectedBillingApprovalRowIndex, setRestoreSelectedBillingApprovalRowIndex] = useState<number>(undefined);
    const [selectedExpenseRowIndex, setSelectedExpenseRowIndex] = useState<number>(undefined);
    const [selectedBillingApprovalRowIndex, setSelectedBillingApprovalRowIndex] = useState<number>(undefined);
    const [billingApprovals, setBillingApprovals] = useState<BillingApproval[]>(undefined);
    const [billingApprovalProjectInfo, setBillingApprovalProjectInfo] = useState<BillingApproval>(undefined);
    const [billingExpenses, setBillingExpenses] = useState<TimeAndExpense[]>(undefined);
    const [allBillingExpenses, setAllBillingExpenses] = useState<TimeAndExpense[]>(undefined);
    const [allLandmanExpenses, setAllLandmanExpenses] = useState<LandmanExpense[]>(undefined);
    const [projectIdForDialog, setProjectIdForDialog] = useState<number>(undefined);
    const [flagAndCorrectionNotes, setFlagAndCorrectionNotes] = useState<FlagNote[]>(undefined);
    const selectedBillingApprovalRowIndexRef = useRef(selectedBillingApprovalRowIndex);
    const [tsdiAccounts, setTsdiAccounts] = useState<Array<{ code: number, description: string}>>(undefined);
    const billingApprovalsLengthRef = useRef(null);
    const [expandAllSections, setExpandAllSections] = useState<boolean>(true);
    // const { isDirty, dirtyFields } = formState;

    const approvalStates = {
        approved: 1,
        corrected: 2,
        flagged: 3
    };

    const statusOptionValues = [
        {value: '0', label: 'ALL'},
        {value: '2', label: 'Waiting'},
        {value: '3', label: 'Corrected'},
        {value: '1', label: 'Approved'},
        {value: '5', label: 'Flagged'}
    ];
    const officeOptionValues = [
        {value: '1', label: 'ALL'},
        {value: '2', label: 'CO'},
        {value: '3', label: 'IH'},
        {value: '4', label: 'MD'},
        {value: '5', label: 'OK'},
        {value: '6', label: 'PA'},
        {value: '7', label: 'RN'},
        {value: '8', label: 'TX'}
    ];

/*     const timeAndExpenseData = [
        { name: 'Quan shoo', number: 1, acctNo: 200, days: 2, periodDays: 2, billRate: 250, payRate: 400,
            billedServices: 10, miles: 10, mileage: 20, meals: 200, hotel: 200, copies: 100, phone: 50}
        ]; */

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (allBillingExpenses) {
            dispatch(actions.layout.showDialog(DialogList.PERSONNEL_SUMMARY));
        }
    }, [allBillingExpenses]);

    useEffect(() => {
        if (payPeriodSearchTerm && payPeriodSearchTerm !== '') {
            updatePayPeriodSearchOptions();
        }
    }, [payPeriodSearchTerm]);

    useEffect(() => {
        if (!!clientBillingInfo) {
            const clientNumber = billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber;
            const projectNumber = billingApprovals[selectedBillingApprovalRowIndex]?.projectNo;
            if (!!clientNumber && !!projectNumber) {
                getBillingExpenses(clientNumber, projectNumber);
            }
        }
    }, [clientBillingInfo]);

    useEffect(() => {
        if (!!billingApprovalsRendered && !!billingApprovals && billingApprovals.length > 0) {
            setBillingApprovalsRendered(false);
        }
    }, [billingApprovalsRendered]);

    useEffect(() => {
        if (!!workDescriptionLandmen && workDescriptionLandmen?.length > 0) {
            getWorkDescriptionsForLandman(workDescriptionLandmen[0]);
        }
    }, [workDescriptionLandmen]);

    useEffect(() => {
        if (!!landmanWorkDescriptions && landmanWorkDescriptions?.length > 0) {
            let workHours = 0;
            let workDays = 0;
            landmanWorkDescriptions.forEach((lwd) => {
                workHours += !isNaN(lwd?.hours) ? lwd?.hours : 0;
                workDays += !isNaN(lwd?.days) ? lwd?.days : 0;
            });
            setValue(`projectHours`, workHours);
            setValue(`projectDays`, workDays);

/*             const period = payPeriods.find((pp) =>
                pp?.name.replace('-', '') === selectedPayPeriod
            );

            const date1 = new Date(period.endDate);
            const date2 = new Date(period.beginDate);

            // Calculate the difference in milliseconds
            const diffInMs = Math.abs(date2.getTime() - date1.getTime());

            // Convert milliseconds to days
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24); */
            const index = !!selectedExpenseRowIndex ? selectedExpenseRowIndex : 0;
            const periodDays = getValues(`timeAndExpenseData[${index}].periodDays`);
            const services = getValues(`timeAndExpenseData[${index}].billedServices`);
            const expenses = getValues(`timeAndExpenseData[${index}].expenses`);
            const miles = getValues(`timeAndExpenseData[${index}].miles`);
            const mileage = getValues(`timeAndExpenseData[${index}].mileage`);
            setValue(`periodDays`, periodDays);
            setValue(`periodHours`, periodDays * 8);
            setValue('services', services);
            setValue('expenses', expenses);
            setValue('miles', miles);
            setValue('mileage', mileage);
        }
    }, [landmanWorkDescriptions]);

    useEffect(() => {
        if (selectedBillingApprovalRowIndex !== undefined) {
            selectedBillingApprovalRowIndexRef.current = selectedBillingApprovalRowIndex;
            const clientNumber = billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber;
            const projectNumber = billingApprovals[selectedBillingApprovalRowIndex]?.projectNo;
            const projectId = billingApprovals[selectedBillingApprovalRowIndex]?.id;
            if (!!billingApprovals && billingApprovals.length > 0 && !!clientNumber && !!projectNumber && !!projectId) {
                setProjectIdForDialog(projectId);
                getBillingApprovalProjectInfo();
                getClientBillingInfo(billingApprovals[selectedBillingApprovalRowIndex].clientNumber);
                initializeFlagAndCorrectionNotesSearchSettings();
                getWorkDescriptionLandmen();
                setBillingExpenses([]);
            }
        }
    }, [selectedBillingApprovalRowIndex]);

    useEffect(() => {
        if (!!billingApprovals && billingApprovals?.length > 0) {
            billingApprovalsLengthRef.current = billingApprovals.length;
            if (restoreSelectedBillingApprovalRowIndex !== undefined) {
                setSelectedBillingApprovalRowIndex(restoreSelectedBillingApprovalRowIndex);
                setRestoreSelectedBillingApprovalRowIndex(undefined);
            } else {                
                setSelectedBillingApprovalRowIndex(0);
            }
            resetBillingApprovalsForm(billingApprovals);
            setBillingApprovalsRendered(false);
            initializeFlagAndCorrectionNotesSearchSettings();
            setBillingExpenses([]);
        }
    }, [billingApprovals]);

    useEffect(() => {
        if (flagAndCorrectionNoteSearchOptions && flagAndCorrectionNoteSearchOptions.hasFilters()) {
            getFlagAndCorrectionNotes();
        }
    }, [flagAndCorrectionNoteSearchOptions]);

    useEffect(() => {
        if (Array.isArray(allLandmanExpenses) && allLandmanExpenses.length > 0) {
            showLandmanExpensesDialog();
        }
    }, [allLandmanExpenses]);

    useEffect(() => {
        if (!!selectedExpenseRowIndex || selectedExpenseRowIndex === 0) {
            if (!!billingExpenses && billingExpenses?.length >= selectedExpenseRowIndex) {
                setLandmanWorkDescriptions([]);
                getWorkDescriptionsForLandman(billingExpenses[selectedExpenseRowIndex]?.number);
            }
        }
    }, [selectedExpenseRowIndex]);

    useEffect(() => {
        if (!!billingExpenses && billingExpenses?.length > 0) {
            let daysTotal = 0;
            let periodDaysTotal = 0;
            let expensesTotal = 0;
            let billedServicesTotal = 0;
            let totalOther = 0;
            let onlineSubTotal = 0;
            let copiesTotal = 0;
            let milesTotal = 0;
            let mileageTotal = 0;
            let mealsTotal = 0;
            let abstractTotal = 0;
            let postageTotal = 0;
            let shippingTotal = 0;

            billingExpenses.forEach((x) => {
              daysTotal += Number(x.days);
              periodDaysTotal += Number(x.periodDays);
              expensesTotal += Number(x.expenses);
              billedServicesTotal += Number(x.billedServices);
              totalOther += x?.otherExpense;
              copiesTotal += Number(x?.copies);
              milesTotal += Number(x?.miles);
              mileageTotal += Number(x?.mileage);
              mealsTotal += Number(x?.meals);
              onlineSubTotal += x?.phone;
              abstractTotal += x?.abstract;
              postageTotal += x?.postage;
              shippingTotal += x?.shipping;
            });

            // Set form values once
            setValue('daysTotal', daysTotal.toFixed(2));
            setValue('periodDaysTotal', periodDaysTotal.toFixed(2));
            setValue('expensesTotal', expensesTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(`otherTotal`, (totalOther - onlineSubTotal).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(`copiesTotal`, copiesTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(`milesTotal`, milesTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(`mileageTotal`, mileageTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(`mealsTotal`, mealsTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(
                'billedServicesTotal', billedServicesTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(
                'abstractTotal', abstractTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(
                'postageTotal', postageTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(
                'shippingTotal', shippingTotal.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );
            setValue(
                'servicesAndExpensesTotal',
                (expensesTotal + billedServicesTotal).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            );

            // Optional external setter
            setBillingTotal(billedServicesTotal);
            setSelectedExpenseRowIndex(0);
        }
    }, [billingExpenses]);

    useEffect(() => {
        if (payPeriodSearchOptions) {
            getPayPeriods();
        }
    }, [payPeriodSearchOptions]);

    const onCreate = () => {
        // Put all initialization code here.
        reset(!!billingExpenses ? billingExpenses : new TimeAndExpense());
        setDlcOffices(officeOptionValues);
        resetBillingApprovalsForm();
        setBillingApprovals([]);
        getManagers();
        if (!projects) {
            setProjects([new Project()]);
        }
        getBillingAccounts();
        initializePayPeriodSearchSettings();

        document.addEventListener('keydown', handleKeyDown);
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    const onDestroy = () => {
        document.removeEventListener('keydown', handleKeyDown);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'ArrowDown') {
        moveToNextRecord();
    } else if (e.key === 'ArrowUp') {
        moveToPreviousRecord();
    }
    };

    const onSubmit = () => {
        // Put all form saving/validation code here.
    };

    const setSelectedManagerNumber = (managerNumber: string) => {
        setSelectedManager(managerNumber);
        // const managerNumberElement = document.getElementById('lmsNumber') as HTMLInputElement;
        // managerNumberElement.value = managerNumber;
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
        if (!!showViewFlagNotes) {
            showFlagNotesDialog();
            setShowViewFlagNotes(false);
        }
    };

    const handleRefreshBillingData = (refreshType: number) => {
        const payPeriod = Number(selectedPayPeriod ? selectedPayPeriod.replace('-', '') : Number(undefined));
        const manager = Number(selectedManager);
        const clientNumber = Number(getValues()?.clientNumber);
        const projectNumber = Number(getValues()?.projectNumber);
        if (isNaN(payPeriod)) {
            window.alert('Please select a valid pay period.');
            hideDialog();
            return;
        }
        if (isNaN(manager)) {
            window.alert('Please select a manager.');
            hideDialog();
            return;
        }
        if (isNaN(clientNumber)) {
            window.alert('invalid client number');
            hideDialog();
            return;
        }
        if (isNaN(projectNumber)) {
            window.alert('invalid project number');
            hideDialog();
            return;
        }
        if (refreshType === 1) {
            generateBillingDataForManager(payPeriod, manager);
        } else if (refreshType === 2) {
            generateBillingDataForClient(payPeriod, manager, clientNumber);
        } else if (refreshType === 3) {
            generateBillingDataForProject(payPeriod, manager, clientNumber, projectNumber);
        }
    };

    const handleFlagBillingEntry = (reason: string) => {
        const flagNote = {
            billingId: billingApprovals[selectedBillingApprovalRowIndex].billingId,
            note: reason,
            owner: appContext.currentUser.username.split('@')[0],
            type: noteMode === false ? 'F' : 'C',
            created: new Date()
        };
        addFlagNote(flagNote);
        setRestoreSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndex);
        const approvalUpdatepayload = generateBillingApprovalUpdatePayload(flagNote.type === 'F' ? approvalStates.flagged : approvalStates.corrected);
        updateBillingApproval(approvalUpdatepayload);
    };

    const loadData = () => {
        setBillingApprovals([]);
        getBillingApprovals();
    };

    const refresh = () => {
        showDialog(DialogList.REFRESH_BILLING_DATA);
    };

    const showReportsDialog = () => {
        reportOptions();
    };

    const expandAllPanels = () => {
        setExpandAllSections(true);
        // alert('Todo: Expand all the collapsible panels like DLC Menus.');
    };

    const collapseAllPanels = () => {
        setExpandAllSections(false);
        // alert('Todo: Collapse all the collapsible panels like DLC Menus.');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const exportToExcel = () => {        
        showDialog(DialogList.EXCEL_FILE);
        // alert('Todo: Create a dialog for exporting to Excel file like DLC Menus.');
    };

    const personnelSummary = () => {
        const clientNumber = billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber;
        getAllBillingExpenses(clientNumber, 0);
    };

    const showFlagReasonDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.FLAG_REASON_DIALOG));
    };

    const showLandmanExpensesDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.VIEW_LM_EXPENSES));
    };

    const showFlagNotesDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.SHOW_FLAG_NOTES_DIALOG));
    };

    const onApprovalStatus = (status: number) => {
        if (isNaN(status) || status === 1) {
            status = null;
        } else {
            status = 1;
        }
        const approvalUpdatepayload = generateBillingApprovalUpdatePayload(status);
        updateBillingApproval(approvalUpdatepayload);
    };

    const onChangeShowPreviousBilling = () => {
        setShowPreviousBilling(!showPreviousBilling);
    };

    const moveToLastRecord = () => {
        alert('Todo: Approve expenses a la DLC Menus.');
    };

    const moveToFirstRecord = () => {
        alert('Todo: Approve expenses a la DLC Menus.');
    };

    const moveToNextRecord = () => {
        // alert('Todo: Approve expenses a la DLC Menus.');
        if (selectedBillingApprovalRowIndexRef.current < billingApprovalsLengthRef.current) {
            setSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndexRef.current + 1);
            const billingApprovalRow = document.getElementById('billingApprovalRow' + (selectedBillingApprovalRowIndexRef.current + 1).toString());
            billingApprovalRow.focus();
        }
    };

    const moveToPreviousRecord = () => {
        // alert('Todo: Approve expenses a la DLC Menus.');
        if (selectedBillingApprovalRowIndexRef.current > 0) {
            setSelectedBillingApprovalRowIndex(selectedBillingApprovalRowIndexRef.current - 1);
            const billingApprovalRow = document.getElementById('billingApprovalRow' + (selectedBillingApprovalRowIndexRef.current - 1).toString());
            billingApprovalRow.focus();
        }
    };

    const moveToNextTneEntry = () => {
        if (!!billingExpenses && billingExpenses?.length > selectedExpenseRowIndex + 1 ) {
            setSelectedExpenseRowIndex(selectedExpenseRowIndex + 1);
        }
    };

    const moveToPreviousTneEntry = () => {
        if (!!billingExpenses && billingExpenses?.length > 0 && selectedExpenseRowIndex > 0) {
            setSelectedExpenseRowIndex(selectedExpenseRowIndex - 1);
        }
    };

    const moveToFirstTneEntry = () => {
        if (!!billingExpenses && billingExpenses?.length > 0) {
            setSelectedExpenseRowIndex(0);
        }
    };

    const moveToLastTneEntry = () => {
        if (!!billingExpenses && billingExpenses?.length > 0) {
            setSelectedExpenseRowIndex(billingExpenses.length - 1);
        }
    };

    const updatePayPeriodSearchOptions = () => {
        setFetchNextPayPeriodsPage(true);
        console.log(fetchNextPayPeriodsPage);
        let newPayPeriodSearchOptions = _.cloneDeep(payPeriodSearchOptions);
        newPayPeriodSearchOptions.clearFilters();
        newPayPeriodSearchOptions.addPaging(1, 200);
        const payPeriod = Number(payPeriodSearchTerm.replace('-', ''));
        if (!isNaN(payPeriod)) {
            newPayPeriodSearchOptions.addFilter(new ODataFilter('PERIOD_NO', ODataFilterOperators.Contains, payPeriod));
        }
        setPayPeriodSearchOptions(newPayPeriodSearchOptions);
    };

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const initialPayPeriodSearchOptions = ODataOptions.from(tableConfig);
        initialPayPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const currentDate2 = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        initialPayPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        initialPayPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        
        setPayPeriodSearchOptions(initialPayPeriodSearchOptions);
    };

    const initializeBillingApprovalProjectInfoSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 1,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingApprovalsSearchOptions = ODataOptions.from(tableConfig);
        billingApprovalsSearchOptions.addOrderBy('PR_ID', ODataOrderByDirection.Descending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[tsd_mgr]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[period_no]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[cl_no]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.acctNo) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('psi.ACCT_NO', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.acctNo?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.projectId) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[pr_id]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.projectId?.toString()));
        }
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.projectNo) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('pba.[pr_no]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.projectNo?.toString()));
        }
        // billingApprovalsSearchOptions?.addFilter(new ODataFilter('LM.State', ODataFilterOperators.Equals, 'p.OFFICE'));
        return billingApprovalsSearchOptions.toString();
    };

    const initializeFlagAndCorrectionNotesSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'NOTE_ID',
            pageNumber: 1,
            columns: []
        };
        const newFlagAndCorrectionNoteSearchOptions = ODataOptions.from(tableConfig);
        newFlagAndCorrectionNoteSearchOptions.addOrderBy('Created', ODataOrderByDirection.Descending);
        if ( selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.billingId) {
            newFlagAndCorrectionNoteSearchOptions?.addFilter(new ODataFilter('[BILL_ID]', ODataFilterOperators.Equals, billingApprovals[selectedBillingApprovalRowIndex]?.billingId?.toString()));
        }
        
        setFlagAndCorrectionNoteSearchOptions(newFlagAndCorrectionNoteSearchOptions);
    };

    const initializeBillingApprovalSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingApprovalsSearchOptions = ODataOptions.from(tableConfig);
        billingApprovalsSearchOptions.addOrderBy('ba.[CL_NO]', ODataOrderByDirection.Ascending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('ba.[tsd_mgr]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('[period_no]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if (!!selectedClient && selectedClient?.clientNumber > 0) {
            billingApprovalsSearchOptions?.addFilter(new ODataFilter('ba.[cl_no]', ODataFilterOperators.Equals, selectedClient.toString()));
        }
        
        return billingApprovalsSearchOptions.toString();
    };

    const initializeBillingExpenseSearchSettings = (clientNumber: number, projectNumber: number) => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'PR_ID',
            pageNumber: 1,
            columns: []
        };
        const billingExpenseSearchOptions = ODataOptions.from(tableConfig);
        billingExpenseSearchOptions.addOrderBy('bte.[BILL_ID]', ODataOrderByDirection.Descending);
        if (!!selectedManager && selectedManager.length > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('b.[TSD_MGR]', ODataFilterOperators.Equals, selectedManager));
        }
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[PERIOD_NO]', ODataFilterOperators.Equals, selectedPayPeriod.replace('-', '')));
        }
        if (!!projectNumber && projectNumber > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[PR_NO]', ODataFilterOperators.Equals, projectNumber));
        }
        if (!!clientNumber && clientNumber > 0) {
            billingExpenseSearchOptions?.addFilter(new ODataFilter('[CL_NO]', ODataFilterOperators.Equals, clientNumber));
        }
        
        return billingExpenseSearchOptions.toString();
    };

    const initializeManagerSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const managerSearchOptions = ODataOptions.from(tableConfig);
        managerSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        currentDate.setMonth(new Date().getMonth());
        const endDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        managerSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        managerSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));

        return managerSearchOptions.toString();
    };

    const getClientBillingInfo = async (clientNumber: number) => {
        const result = await get(`/v1.0/ClientProjectMaintenance/client/billing/info/${clientNumber}`);

        if (response.ok) {
            console.log('Client Billing Info', result);
            setClientBillingInfo(result);
        }
    };

    const getPayPeriods = async () => {        
        const queryString = payPeriodSearchOptions.toString();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = insertCharAt(pp.periodNumber.toString(), '-', insertIndex);
                return { id: pp.id, name: ppString, beginDate: pp.beginDate, endDate: pp.endDate };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const getBillingApprovalProjectInfo = async () => {        
        const queryString = initializeBillingApprovalProjectInfoSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/billing/approval/projectinfo${queryString}`);

        if (response.ok) {
            setBillingApprovalProjectInfo(result);
        } else {
            console.log('Unable to get billing approval project data!!!');
        }
    };

    const getBillingApprovals = async () => {        
        const queryString = initializeBillingApprovalSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/billing/approvals${queryString}`);

        if (response.ok) {
            setBillingApprovals(result.items);
        } else {
            console.log('Unable to get billing approval data!!!');
        }
    };

    const generateBillingDataForManager = async (payPeriod: number, managerNumber: number) => {
        setGenerating(true);
        post(`/v1.0/ClientProjectMaintenance/payPeriod/${payPeriod}/manager/${managerNumber}/billing/generate`).then((result) => {
            if (response.ok) {
                alert('Finished Generating Billing data');
            } else {
                console.log('Unable to generate billing data!' + result);
            }
        }).catch(err => alert(err)).then(() => setGenerating(false));
        hideDialog();
    };

    const generateBillingDataForClient = async (payPeriod: number, managerNumber: number, clientNumber: number) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/payPeriod/${payPeriod}/manager/${managerNumber}/client/${clientNumber}/billing/generate`);

        if (response.ok) {
            console.log('Finished Generating Billing data');
            hideDialog();
        } else {
            console.log('Unable to generate billing data!' + result);
        }
    };

    const generateBillingDataForProject = async (payPeriod: number, managerNumber: number, clientNumber: number, projectNumber: number) => {    
        let result = await post(`/v1.0/ClientProjectMaintenance/payPeriod/${payPeriod}/manager/${managerNumber}/client/${clientNumber}/project/${projectNumber}/billing/generate`);

        if (response.ok) {
            console.log('Finished Generating Billing data');
            hideDialog();
        } else {
            console.log('Unable to generate billing data!' + result);
        }
    };

    const addFlagNote = async (payload: FlagNote) => {    
        let result = await post(`/v1.0/AccountsPayable/billing/flagnote`, payload);

        if (response.ok) {
            console.log('Note added');
        } else {
            console.log('Unable to add flag note!' + result);
        }
    };

    const getFlagAndCorrectionNotes = async () => {
        setNoteMode(false);
        const queryString = flagAndCorrectionNoteSearchOptions.toString();
        let result = await get(`/v1.0/AccountsPayable/billing/flagnotes${queryString}`);

        if (response.ok) {
            setFlagAndCorrectionNotes(result);
        } else {
            console.log('Unable to add flag note!' + result);
        }
    };

    const generateBillingApprovalUpdatePayload = (approvalStatus: number) => {
        const payload: BillingApproval = {
            payPeriod: selectedPayPeriod,
            clientNumber: billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber,
            managerNumber: !isNaN(Number(selectedManager)) ? Number(selectedManager) : null,
            projectNo: billingApprovals[selectedBillingApprovalRowIndex]?.projectNo,
            subCode: !!billingApprovals[selectedBillingApprovalRowIndex]?.subCode ? billingApprovals[selectedBillingApprovalRowIndex].subCode : null,
            altSubCode: !!billingApprovals[selectedBillingApprovalRowIndex]?.altSubCode ? billingApprovals[selectedBillingApprovalRowIndex].altSubCode : null,
            acctNo: !!billingApprovals[selectedBillingApprovalRowIndex]?.acctNo ? billingApprovals[selectedBillingApprovalRowIndex].acctNo : null,
            approvalDate: approvalStatus === 1 ? new Date() : null,
            modifiedDate: new Date(),
            approvalStatus: !!approvalStatus ? approvalStatus.toString() : null
        };

        return payload;
    };

    const updateBillingApproval = async (payload: BillingApproval) => {
        let result = await put(`/v1.0/AccountsPayable/billing/approvals`, payload);

        if (response.ok && result === 1) {
            setBillingApprovals([]);
            getBillingApprovals();
        } else {
            console.log('Unable to get billing approval data!!!');
        }
    };

    const getBillingExpensesAndSetSelectedIndex = async (clientNumber: number, projectNumber: number, index: number) => {
        setSelectedBillingApprovalRowIndex(index);
    };

    const getBillingExpenses = async (clientNumber: number, projectNumber: number) => {
        const queryString = initializeBillingExpenseSearchSettings(clientNumber, projectNumber);
        let result = await get(`/v1.0/AccountsPayable/billing/expenses${queryString}`);

        if (response.ok) {
            setBillingExpenses(result.items);
        } else {
            console.log('Unable to get billing expense data!!!');
        }
    };

    const getAllBillingExpenses = async (clientNumber: number, projectNumber: number) => {
        const queryString = initializeBillingExpenseSearchSettings(clientNumber, projectNumber);
        let result = await get(`/v1.0/AccountsPayable/billing/expenses${queryString}`);

        if (response.ok) {
            setAllBillingExpenses(result.items);
        } else {
            console.log('Unable to get all billing expense data!!!');
        }
    };

    const getAllLandmanExpenses = async (landmanNumber: number) => {
        const clientNumber = !isNaN(billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.clientNumber) ?
            billingApprovals[selectedBillingApprovalRowIndexRef.current].clientNumber : 0;
        const projectNumber = !isNaN(billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.projectNo) ?
            billingApprovals[selectedBillingApprovalRowIndexRef.current].projectNo : 0;
        const subcode = !isNaN(billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.subCode) &&
            billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.subCode ?
            billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.subCode : 0;
        const altSubcode = !isNaN(billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.altSubCode) &&
            billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.altSubCode ?
            billingApprovals?.[selectedBillingApprovalRowIndexRef.current]?.altSubCode : 0;

        const periodNumber = !isNaN(Number(selectedPayPeriod)) ? Number(selectedPayPeriod) : 0;
        // tslint:disable-next-line: max-line-length
        let result = await get(`/v1.0/AccountsReceivable/billing/client/${clientNumber}/project/${projectNumber}/subcode/${subcode}/altSubcode/${altSubcode}/landman/${landmanNumber}/payperiod/${periodNumber}/expenses`);

        if (response.ok) {
            setAllLandmanExpenses(result);
        } else {
            console.log('Unable to get landman expenses.');
        }
    };

    const getWorkDescriptionLandmen = async () => {
        const clientNumber = billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber;
        const projectNumber = billingApprovals[selectedBillingApprovalRowIndex]?.projectNo;
        const payPeriodNumber = Number(selectedPayPeriod);
        if (!isNaN(clientNumber) && !isNaN(projectNumber) && !isNaN(payPeriodNumber)) {
            let result = await get(`/v1.0/ClientProjectMaintenance/client/${clientNumber}/project/${projectNumber}/period/${payPeriodNumber}/billing/workdescriptions/landmen`);

            if (response.ok) {
                setWorkDescriptionLandmen(result);
            } else {
                console.log('Unable to get landmen for work description data!!!');
            }
        }
    };

    const getWorkDescriptionsForLandman = async (landmanNumber: number) => {
        const clientNumber = billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber;
        const projectNumber = billingApprovals[selectedBillingApprovalRowIndex]?.projectNo;
        const payPeriodNumber = Number(selectedPayPeriod);
        if (!isNaN(clientNumber) && !isNaN(projectNumber) && !isNaN(payPeriodNumber) && !isNaN(landmanNumber)) {
            let result = await get(`/v1.0/ClientProjectMaintenance/client/${clientNumber}/project/${projectNumber}/period/${payPeriodNumber}/billing/workdescriptions/landman/${landmanNumber}`);

            if (response.ok) {
                setLandmanWorkDescriptions(result);
            } else {
                console.log('Unable to get landman work description data!!!');
            }
        }
    };

    const getManagers = async () => {        
        const queryString = initializeManagerSearchSettings();
        let result = await get(`/v1.0/ClientProjectMaintenance/project/managers${queryString}`);

        if (response.ok) {
            setManagers(result);
        } else {
            console.log('Unable to get manager data!!!');
        }
    };

    const setSelectedPayPeriodValue = (value: string) => {
        if (!value) {
            setSelectedPayPeriod(undefined);
            return;
        }
        if (Array.isArray(payPeriods)) {
            const labelValue: PayPeriod = payPeriods.find((pp) =>
                pp.id.toString() === value
            );
            if (!!labelValue?.name) {
                setSelectedPayPeriod(labelValue.name.toString().replace('-', ''));
            }
        }
    };

    const getStatusString = (status: string) => {
        switch (status) {
            case '1':
                return 'Approved';
            case '2':
                return 'Corrected';
            case '3':
                return 'Flagged';
            case null :
            default :
                return 'Waiting';
        }
    };

    function insertCharAt(str: string, charToInsert: string, index: number) {
        return str.slice(0, index) + charToInsert + str.slice(index);
    }

/*     const displayProjectBillingApprovals = (b: BillingApproval, index: number) => {
        return (
            <tr
                key={index}
                tabIndex={0}
                id={'billingApprovalRow' + index}
                onFocus={() => getBillingExpensesAndSetSelectedIndex(billingApprovals[index].clientNumber, billingApprovals[index].projectNo, index)}
                className="table-item-hover"
                style={{ textAlign: 'center' }}
            >
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].id`}
                        type="text"
                        defaultVal={b?.id?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '10%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].managerName`}
                        type="text"
                        defaultVal={b?.managerName}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].clientNumber`}
                        type="number"
                        defaultVal={b?.clientNumber?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '10%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].clientName`}
                        type="text"
                        defaultVal={b?.clientName}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{  width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].projectNo`}
                        defaultVal={b?.projectNo?.toString()}
                        style={{ width: '40px'}}
                        // TODO: Finish billing code validation
                        // style={(clientValidations?.length > 0 && !clientValidations[index]) ? { width: '40px', border: '2px solid red'} : { width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].projectName`}
                        defaultVal={b?.projectName}
                        style={{ width: '100px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '3%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].subCode`}
                        defaultVal={b?.subCode?.toString()}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '8%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].sectionName`}
                        defaultVal={b?.sectionName}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '4%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].altSubCode`}
                        defaultVal={b?.altSubCode?.toString()}
                        style={{ width: '40px'}}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                    />
                </td>
                <td style={{ width: '4%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].acctNo`}
                        defaultVal={b?.acctNo?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].billBy`}
                        register={registerBillingApprovalsForm}
                        defaultVal={b?.billBy?.toString()}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].invoicedBy`}
                        defaultVal={b?.invoicedBy?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].total`}
                        register={registerBillingApprovalsForm}
                        defaultVal={b?.total?.toString()}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].totalAfe`}                                        
                        defaultVal={b?.total?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].totalBilled`}                                        
                        defaultVal={b?.totalAfe?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].approvalDate`}                                        
                        defaultVal={b?.approvalDate?.toString()}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
                <td style={{ width: '5%' }}>
                    <RHFInputBox
                        name={`billingApprovals[${index}].approvalStatus`}                                        
                        defaultVal={getStatusString(b?.approvalStatus?.toString())}
                        register={registerBillingApprovalsForm}
                        errors={errors}
                        style={{ color: 'black', backgroundColor: b?.approvalStatus === '1' ? '#66FF00' : '#26F7FD',  width: '100%' }}
                        bodyStyle={{ width: '100%' }}
                    />
                </td>
            </tr>
        );
    };
 */
    const displayProjectBilling = () => {
        return  <table className={'project-billing'} style={{textAlign: 'left'}}>
                <thead className={'project-billing'}>
                    <tr>
                        <th>#</th>
                        <th>Manager</th>
                        <th>#</th>
                        <th>Client</th>
                        <th>#</th>
                        <th>Project</th>
                        <th title={'Subcode'}>SC</th>
                        <th>Survey</th>
                        <th title={'AltSubcode'}>ASC</th>
                        <th>Acct</th>
                        <th>BB</th>                        
                        <th>Invoiced By</th>
                        <th>Total</th>
                        <th>AFE Total</th>
                        <th>Total Billed</th>
                        <th>Approval Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody className={'project-billing'} style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {billingApprovals && billingApprovals?.length > 0 && billingApprovals?.map(
                    (b: BillingApproval, index: number) => {
                    if (index === billingApprovals.length - 1 && !billingApprovalsRendered) {
                        setBillingApprovalsRendered(true);
                    }
                    return (
                            <tr
                                key={index}
                                tabIndex={0}
                                id={'billingApprovalRow' + index}
                                onClick={() => getBillingExpensesAndSetSelectedIndex(billingApprovals[index].clientNumber, billingApprovals[index].projectNo, index)}
                                className="table-item-hover"
                                style={{ textAlign: 'center' }}
                            >
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].id`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.id?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '6%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].managerName`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.managerName}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`billingApprovals[${index}].clientNumber`}
                                        readOnly={true}
                                        type="text"
                                        defaultVal={b?.clientNumber?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].clientName`}
                                        type="text"
                                        defaultVal={b?.clientName}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].projectNo`}
                                        defaultVal={b?.projectNo?.toString()}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].projectName`}
                                        defaultVal={b?.projectName}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].subCode`}
                                        defaultVal={b?.subCode?.toString()}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].sectionName`}
                                        defaultVal={b?.sectionName}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].altSubCode`}
                                        defaultVal={b?.altSubCode?.toString()}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].acctNo`}
                                        defaultVal={b?.acctNo?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].billBy`}
                                        register={registerBillingApprovalsForm}
                                        defaultVal={b?.billBy?.toString()}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].invoicedBy`}
                                        defaultVal={b?.invoicedBy?.toString()}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].total`}
                                        register={registerBillingApprovalsForm}
                                        defaultVal={formatCurrencyString(b?.total)}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%', fontSize: '15px' } : { width: '100%', fontSize: '15px' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].totalAfe`}                                        
                                        defaultVal={formatCurrencyString(Number(b?.totalAfe))}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%', fontSize: '15px' } : { width: '100%', fontSize: '15px' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].totalBilled`}                                        
                                        defaultVal={formatCurrencyString(b?.totalBilled)}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: (b?.totalBilled > (Number(b?.totalAfe) * (b?.afeWarnPct / 100))) ?
                                                'rgba(204, 85, 0, 0.78)' : '#FFFF77', width: '100%', fontSize: '15px' } : { width: '100%', fontSize: '15px' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].approvalDate`}                                        
                                        defaultVal={formatDate(b?.approvalDate)}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={(!!selectedBillingApprovalRowIndex || selectedBillingApprovalRowIndex === 0) && selectedBillingApprovalRowIndex === index ?
                                            {backgroundColor: '#FFFF77', width: '100%' } : { width: '100%' } }
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '5%' }}>
                                    <RHFInputBox
                                        readOnly={true}
                                        name={`billingApprovals[${index}].approvalStatus`}                                        
                                        defaultVal={getStatusString(b?.approvalStatus?.toString())}
                                        register={registerBillingApprovalsForm}
                                        errors={errors}
                                        style={{ color: 'black', backgroundColor: b?.approvalStatus === '1' ? '#66FF00' :
                                            (b?.approvalStatus === '2' ? 'rgba(204, 85, 0, 0.78)' :
                                                (b?.approvalStatus === '3' ? '#B22222' : '#26F7FD')),  width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                            </tr>

                    );
                })}
                </tbody>
            </table>;
    };

    const formatDate = (dateValue: Date | string | null | undefined) => {
        if (!dateValue) {
            return '';
        }

        if (dateValue instanceof Date) {
            const month = String(dateValue.getMonth() + 1).padStart(2, '0');
            const day = String(dateValue.getDate()).padStart(2, '0');
            const year = dateValue.getFullYear();

            return `${month}/${day}/${year}`;
        }

        const str = dateValue.toString();

        if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
            const [year, month, day] = str.substring(0, 10).split('-');
            return `${month}/${day}/${year}`;
        }

        return '';
    };

    const displayProjectInformation = () => {
        return (<>
            <Form
                onSubmit={loadData}
            >
                <FormRow>
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client.Project No."
                        id={`prospect`}
                        readOnly={true}
                        defaultVal={!!billingApprovals && billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber !== undefined ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.clientNumber?.toString() +
                                '.' + billingApprovals[selectedBillingApprovalRowIndex]?.projectNo : ''}
                        name={`prospect`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '450%' }}
                        bodyStyle={{ width: '45%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client"
                        id={`clientName`}
                        name={`clientName`}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.clientName : ''}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Project"
                        id={`projectName`}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.projectName : ''}
                        name={`projectName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{display: 'flex', alignItems: 'baseline', width: '60%' }}
                    />

                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <label>Billing Office:&nbsp;</label>
                        <label>{!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.projectOffice : 'OK'}</label>
                    </div>
                    <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                        <label style={{fontWeight: 'bold'}}>{selectedBillingApprovalRowIndex !== undefined ? selectedBillingApprovalRowIndex + 1 : 0}</label>
                        <label>&nbsp;of&nbsp;</label>
                        <label style={{fontWeight: 'bold'}}>{!!billingApprovals ? billingApprovals?.length : (!!selectedBillingApprovalRowIndex ? selectedBillingApprovalRowIndex : 0)}</label>
                    </div>
                </FormRow>
                <FormRow>
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label={'Subcode: '}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.sectionName?.toString() : ''}
                        id={`subCodeName`}
                        name={`subCodeName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label={'AltSubcode: '}
                        readOnly={true}
                        defaultVal={!!billingApprovals ? billingApprovals[selectedBillingApprovalRowIndex]?.altSubCode?.toString() : ''}
                        id={`altSubCodeName`}
                        name={`altSubCodeName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client Day Rate"
                        id={`dayRate`}
                        readOnly={true}
                        defaultVal={!!clientBillingInfo ? clientBillingInfo?.dayRate?.toString() : ''}
                        name={`dayRate`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '35%' }}
                        bodyStyle={{ width: '35%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Account Name"
                        id={`accountName`}
                        readOnly={true}
                        defaultVal={!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.projectAccount : ''}
                        name={`accountName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '60%' }}
                        bodyStyle={{ width: '60%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Approval Status"
                        readOnly={true}
                        id={`approvalStatus`}
                        defaultVal={!!billingApprovals ?
                            getStatusString(billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus?.toString()) : ''}
                        style={{ width: '50%', color: 'black', backgroundColor: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? '#66FF00' :
                            ((!!billingApprovals ?
                                billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '2' ? 'rgba(204, 85, 0, 0.78)' :
                                ((!!billingApprovals ?
                                    billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? '#B22222' : '#26F7FD'))}}
                        name={`approvalStatus`}
                        type="text"
                        register={register}
                        errors={errors}
                        bodyStyle={{ width: '50%' }}
                    />
                </FormRow>
                <FormRow>
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Client LM"
                        id={`contactName`}
                        readOnly={true}
                        defaultVal={!!clientBillingInfo ? clientBillingInfo?.clientLandman : ''}
                        name={`contactName`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Manager"
                        id={`projectManager`}
                        readOnly={true}
                        defaultVal={!!billingApprovalProjectInfo ? billingApprovalProjectInfo?.currentManager : ''}
                        name={`projectManager`}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="Org Mgr/CC"
                        id={`orgMgrCc`}
                        name={`orgMgrCc`}
                        readOnly={true}
                        defaultVal={!!billingApprovals && selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.orgMgrAndCrewChief ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.orgMgrAndCrewChief : ''}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '40%' }}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        labelStyle={{whiteSpace: 'nowrap'}}
                        label="County, State"
                        id={`countyAndState`}
                        readOnly={true}
                        name={`countyAndState`}
                        defaultVal={!!billingApprovals && selectedBillingApprovalRowIndex !== undefined && !!billingApprovals[selectedBillingApprovalRowIndex]?.orgMgrAndCrewChief ?
                            (!!billingApprovals[selectedBillingApprovalRowIndex]?.county ? billingApprovals[selectedBillingApprovalRowIndex]?.county : '') + ',' +
                            (!!billingApprovals[selectedBillingApprovalRowIndex]?.state  ? billingApprovals[selectedBillingApprovalRowIndex]?.state : '') : ''}
                        type="text"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                        bodyStyle={{ width: '35%' }}
                    />
                </FormRow>
                <FormRow
                    style={{justifyContent: 'center'}}
                >
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to First Record"
                        reactIcon={BiArrowToLeft}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToFirstRecord}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Previous Record"
                        reactIcon={BiLeftArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToPreviousRecord()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Next Record"
                        reactIcon={BiRightArrowAlt}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => moveToNextRecord()}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="Move to Last Record"
                        reactIcon={BiArrowToRight}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={moveToLastRecord}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? 'Revoke Approval' : 'Approve'}
                        reactIcon={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? FaUndo : FaCheckCircle}
                        iconHoverColor="blue"
                        iconStyle={{fill: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '1' ? 'blue' : 'green', width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => onApprovalStatus(Number(billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus))}
                    />
                    <Button
                        style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? 'View Notes' : 'Flag'}
                        reactIcon={(!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? FaPenSquare : FaFlag}
                        iconHoverColor="blue"
                        iconStyle={{fill: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? 'darkblue' : 'red', width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => ((!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') === '3' ? showFlagNotesDialog() : showFlagReasonDialog())}
                    />
                    <Button
                        style={{ display: (!!billingApprovals ?
                            billingApprovals[selectedBillingApprovalRowIndex]?.approvalStatus : '0') !== '3' ? '' : 'none',  height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                        text={''}
                        title="View Notes"
                        reactIcon={FaPenSquare}
                        iconHoverColor="blue"
                        iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                        onClick={() => showFlagNotesDialog()}
                    />
                </FormRow>
            </Form>
        </>);
    };

    const toggleBillingServicesDisplay = () => {
        setShowBilledServices(!showBilledServices);
        let totalServices = 0;
        // let totalDays = 0;
        // let totalPeriodDays = 0;
        // let totalExpenses = 0;
        // let totalOther = 0;
        for (let expenseIndex = 0; expenseIndex < billingExpenses?.length; expenseIndex++) {
            const serviceValue = !showBilledServices ? billingExpenses[expenseIndex]?.billedServices : billingExpenses[expenseIndex]?.paidServices;
            const numericalServiceValue = Number(serviceValue);
            // totalDays += billingExpenses[expenseIndex]?.days;
            // totalPeriodDays += billingExpenses[expenseIndex]?.periodDays;
            totalServices += numericalServiceValue;
            // totalExpenses += billingExpenses[expenseIndex]?.expenses;
            // totalOther += billingExpenses[expenseIndex]?.otherExpense;
            setValue(`timeAndExpenseData[${expenseIndex}].billedServices`, numericalServiceValue);
        }
        setBillingTotal(totalServices);
        // setValue(`daysTotal`, totalDays);
        // setValue(`periodDaysTotal`, totalPeriodDays);
        // setValue(`expensesTotal`, totalExpenses);
        // setValue(`otherTotal`, totalOther);
        setValue(`billedServicesTotal`, Number(Number(totalServices)).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }), { shouldDirty: true }
        );

        const expensesTotalNumber = Number(Number(getValues(`expensesTotal`).replace(',', '')));
        const billedServicesNumber = Number(getValues(`billedServicesTotal`).replace(',', ''));
        setValue(
            'servicesAndExpensesTotal',
            (expensesTotalNumber + billedServicesNumber).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        );
    };

    const formatCurrencyString = (value: number) => {
        if (!value) {
            return '0.00';
        } else {
            return value.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    };

    const handleReport = async (data: AnyObject) => {
        const payload = new BillingSummaryReport();
        payload.reportVariant = data.reportType || 'BillingSummary';
        payload.employeeNumber = null;
        payload.clientNumber = data.clientNumber || null;
        payload.projectNumber = data.projectNumber || null;
        payload.subcode = data.sectionNumber || null;
        payload.manager = data.managerNumber || null;
        payload.extended = data.extended ? 'Y' : null;
        payload.exclude90 = null;
        payload.billingApproval = null;
        payload.workDescFormat = data.wdFormat || null;
        payload.crewChief = null;
        payload.ccNo = data.ccNo || null;
        payload.payPeriod = payPeriods.find(pp => pp?.id?.toString() === data.payPeriod)?.name?.replace('-', '');
        payload.office = officeOptionValues.find(o => o?.value === data.offices)?.label;
        await getBillingSummaryReport(payload);
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const getBillingSummaryReport = async (
        reportParameters: BillingSummaryReport
    ): Promise<void> => {
        const result = await postBinary(`/AccountsPayable/billing/report/summary`, reportParameters);

        if (!responseBinary.ok || result?.byteLength < 1) {
            return;
        }

        const blob = await responseBinary.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'BillingSummaryReport.pdf';
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
    };

    const displayTimeAndExpenses = () => {
        return <div>
            <table className={'project-billing'}>
                <thead className={'project-billing'}>
                    <tr>
                        <th style={{width: '10%'}}>Name</th>
                        <th style={{width: '3%'}}>No.</th>
                        <th style={{width: '3%'}}>Acct</th>
                        <th style={{width: '4%'}}>Days</th>
                        <th style={{width: '4%'}}>Period Days</th>
                        <th style={{width: '4%'}}>Bill Rate</th>
                        <th style={{width: '4%'}}>Pay Rate</th>
                        <th style={{whiteSpace: 'nowrap', width: '5%'}}>
                            <span
                                onClick={() => toggleBillingServicesDisplay()}
                                style={{display: 'inline-block', border: 'solid 1px black'}}
                            >
                                {showBilledServices ? 'Billed Services' : 'Paid Services'}
                            </span>
                        </th>
                        <th style={{width: '4%'}}>Miles</th>
                        <th style={{width: '4%'}}>Mileage</th>
                        <th style={{width: '4%'}}>Meals</th>
                        <th style={{width: '4%'}}>Hotel</th>
                        <th style={{width: '4%'}}>Copies</th>
                        <th style={{width: '4%'}}>OL Subs</th>
                        <th style={{width: '4%'}}>Abstract</th>
                        <th style={{width: '4%'}}>Postage</th>
                        <th style={{width: '4%'}}>Shipping</th>
                        <th style={{width: '4%'}}>Other</th>
                        <th style={{width: '4%'}}>Σ Expenses</th>
                    </tr>
                </thead>
                <tbody className={'project-billing'} style={{width: '100%', maxHeight: '30vh', overflowY: 'scroll'}}>
                {billingExpenses && billingExpenses?.length > 0 && billingExpenses?.map(
                    (x: TimeAndExpense, index: number) => {
/*                     if (index === 0) {
                        setValue(`billedServicesTotal`, 0);
                        setValue(`expensesTotal`, 0);
                        setValue(`servicesAndExpensesTotal`, 0);
                        setValue(`daysTotal`, 0);
                        setValue(`periodDaysTotal`, 0);
                    } */
                    // setValue(`timeAndExpenseData[${index}].billedServices`, showBilledServices ? x?.billedServices : x?.paidServices);
/*                     const totalDays: number = getValues(`daysTotal`);
                    const totalPeriodDays: number = getValues(`periodDaysTotal`);
                    const totalServices: number = getValues(`billedServicesTotal`);
                    const totalExpenses: number = getValues(`expensesTotal`);
                    setValue(`daysTotal`, Number(Number(totalDays) + x.days).toFixed(2));
                    setValue(`periodDaysTotal`, Number(Number(totalPeriodDays) + x.periodDays).toFixed(2)); */
                    // setValue(`billedServicesTotal`, Number(Number(totalServices) + x.billedServices).toFixed(4));
                    // setBillingTotal(totalServices);
                    // setValue(`expensesTotal`, Number(Number(totalExpenses) + x.expenses).toFixed(4));
                    // setValue(`servicesAndExpensesTotal`, Number(Number(getValues(`expensesTotal`)) + Number(getValues(`billedServicesTotal`))).toFixed(4));
                    return (
                        <tr
                            key={index}
                            className="table-item-hover"
                            style={{ textAlign: 'center' }}
                            onClick={() => setSelectedExpenseRowIndex(index)}
                            onDoubleClick={() => getAllLandmanExpenses(billingExpenses[index]?.name === 'Office Expenses' ? 0 : billingExpenses[index]?.number)}
                        >
                            <td style={{ width: '15%' }}>
                                <RHFInputBox
                                    readOnly={true}
                                    name={`timeAndExpenseData[${index}].name`}
                                    defaultVal={x?.name}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%', background: '#d5f7f5' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].number`}
                                    readOnly={true}
                                    defaultVal={x?.number?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '5%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].acctNo`}
                                    readOnly={true}
                                    defaultVal={x?.acctNo?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '4%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].days`}
                                    readOnly={true}
                                    defaultVal={x?.days?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{  width: '7%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].periodDays`}
                                    readOnly={true}
                                    defaultVal={x?.periodDays?.toString()}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].billRate`}
                                    readOnly={true}
                                    defaultVal={x?.billRate?.toString()}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].payRate`}
                                    readOnly={true}
                                    defaultVal={x?.payRate?.toString()}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '7%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].billedServices`}
                                    readOnly={true}
                                    defaultVal={showBilledServices ? x?.billedServices?.toString() : x?.paidServices?.toString()}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].miles`}
                                    readOnly={true}
                                    defaultVal={x?.miles?.toString()}
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].mileage`}
                                    readOnly={true}
                                    defaultVal={x?.mileage?.toString()}
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].meals`}
                                    readOnly={true}
                                    defaultVal={x?.meals?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].hotel`}
                                    defaultVal={x?.hotel?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].copies`}
                                    defaultVal={x?.copies?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].phone`}
                                    defaultVal={x?.phone?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].abstract`}
                                    defaultVal={x?.abstract?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].postage`}
                                    defaultVal={x?.postage?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].shipping`}
                                    defaultVal={x?.shipping?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].otherExpense`}
                                    defaultVal={(x?.otherExpense - x?.phone)?.toFixed(2)}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '6%' }}>
                                <RHFInputBox
                                    name={`timeAndExpenseData[${index}].expenses`}
                                    defaultVal={x?.expenses?.toString()}
                                    type="text"
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                        </tr>
                    );
                })}

                </tbody>
                                <tfoot>
                <tr>
                    <td style={{ width: '7%' }}>
                        <RHFInputBox
                            label={'Services & Expenses'}
                            labelOnLeft={true}
                            name={`servicesAndExpensesTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '4%' }}>
                        <label>Totals:</label>
                    </td>
                    <td style={{ width: '4%' }}>
                        <RHFInputBox
                            name={`daysTotal`}
                            defaultVal={'0'}
                            type="number"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '4%' }}>
                        <RHFInputBox
                            name={`periodDaysTotal`}
                            defaultVal={'0'}
                            type="number"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                        <td style={{ width: '4%' }}>
                        <RHFInputBox
                            name={`blank`}
                            defaultVal={'0'}
                            type="number"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ width: '100%' }}
                            bodyStyle={{display: 'none', width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '4%' }}>
                        <RHFInputBox
                            name={`billedServicesTotal`}
                            defaultVal={!!billingTotal ? billingTotal?.toString() : ''}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`milesTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`mileageTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`mealsTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`hotelTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`copiesTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`phoneTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`abstractTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`postageTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`shippingTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`otherTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                    <td style={{ width: '2.8%' }}>
                        <RHFInputBox
                            name={`expensesTotal`}
                            defaultVal={'0'}
                            type="text"
                            register={register}
                            errors={errors}
                            readOnly={true}
                            style={{ backgroundColor: '#66FF00', width: '100%' }}
                            bodyStyle={{ width: '100%' }}
                        />
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>;
    };

    return (
        <div>
            <PBNavBar/>
            <ClientProjectSearch
                setPayPeriodSearchTerm={setPayPeriodSearchTerm}
                setSelectedClient={setSelectedClient}
                setSelectedManager={setSelectedManagerNumber}
                setSelectedPayPeriod={setSelectedPayPeriodValue}
                managers={managers}
                payPeriods={!!payPeriods && payPeriods.length > 0 ?
                    payPeriods?.map((pp) => { return {id: pp?.id, name: !!pp?.name ? pp?.name : ''}; }) : []}
                runQuery={loadData}
                size={6}
            />
            <form id="projectBillingQueryButtonsForm" onSubmit={handleSubmit(onSubmit)}>
                <Page>
                    <Page.Section width={14}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ textAlign: 'center', verticalAlign: 'middle', justifyContent: 'center', margin: 0, padding: 0 }}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem' }}
                                        text={'Load Data'}
                                        onClick={() => loadData()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Generate'}
                                        onClick={() => refresh()}
                                        disabled={generating}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Reports'}
                                        onClick={() => showReportsDialog()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Expand All'}
                                        onClick={expandAllPanels}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Collapse All'}
                                        onClick={collapseAllPanels}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Excel Export'}
                                        onClick={exportToExcel}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Personnel Summary'}
                                        onClick={() => personnelSummary()}
                                    />
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className={'billing-panel'}>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="Project Information">
                                <Form
                                    onSubmit={handleSubmit(onSubmit)}
                                >
                                    <FormRow>
{/*                                         <FormSelect
                                            label="Pay Period"
                                            name={`payPeriods`}
                                            items={!!payPeriods ? payPeriods : []}
                                            register={register}
                                            style={{ width: '60%' }}
                                            onChange={(e) => setSelectedPayPeriodValue(e.toString())}
                                        /> */}
{/*                                         <RHFSelect
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Manager"
                                            id={`lmsNumber`}
                                            options={!!managers ? managers?.map((m: Landman) => {
                                                return { value: m.lmsNumber, label: m.firstName + ' ' + m.lastName };
                                            }) : [{ value: '1', label: 'Joe Shmoe'}]}
                                            name={`lmsNumber`}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '60%' }}
                                            bodyStyle={{ width: '60%' }}
                                            title={selectedManager}
                                            onChange={(e) => setSelectedManager(e.currentTarget.value)}
                                        />*/}
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Client No."
                                            id={`clientNumber`}
                                            name={`clientNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '45%' }}
                                            bodyStyle={{ width: '45%' }}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Project No."
                                            id={`projectNumber`}
                                            name={`projectNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="Subcode No."
                                            id={`subcodeNumber`}
                                            name={`subcodeNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFInputBox
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            label="AltSubcode No."
                                            id={`altSubcodeNumber`}
                                            name={`altSubcodeNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '40%' }}
                                            bodyStyle={{ width: '40%' }}
                                        />
                                        <RHFSelect
                                            labelOnLeft={true}
                                            labelStyle={{whiteSpace: 'nowrap'}}
                                            bodyStyle={{ width: '40%' }}
                                            style={{ width: '30%' }}
                                            name="office"
                                            label="Office"
                                            options={!!dlcOffices ? dlcOffices : [{ value: 1, label: 'OK'}]}
                                            register={register}
                                            errors={errors}
                                        />
                                        <RHFSelect
                                            labelOnLeft={true}
                                            bodyStyle={{ width: '40%' }}
                                            style={{ width: '50%' }}
                                            name="status"
                                            label="Status"
                                            options={statusOptionValues}
                                            register={register}
                                            errors={errors}
                                        />
                                        <div style={{display: 'flex', whiteSpace: 'nowrap'}}>
                                            <FormLabel text="Show Previous?" />
                                            <FormToggle onChange={onChangeShowPreviousBilling} name={`currentPeriodLandmen`} items={['Yes', 'No']} />
                                        </div>
                                    </FormRow>
                                </Form>
                                <CollapsibleSection
                                    title="Project Information"
                                    forceExpanded={expandAllSections}
                                >
                                    {displayProjectInformation()}
                                </CollapsibleSection>
                                <CollapsibleSection
                                    title="Project Billing"
                                    forceExpanded={expandAllSections}
                                >
                                    <Form
                                        onSubmit={handleSubmitBillingApprovalsForm(onSubmit)}
                                    >
                                        {isAccountingAdmin && displayProjectBilling()}
                                    </Form>
                                </CollapsibleSection>
                                <CollapsibleSection
                                    title="Time & Expenses"
                                    forceExpanded={expandAllSections}
                                >
                                    {displayTimeAndExpenses()}
                                </CollapsibleSection>
                                <CollapsibleSection
                                    forceExpanded={expandAllSections}
                                    title="Work Descriptions"
                                >
                                    <div style={{paddingBottom: '2rem', display: 'flex', justifyContent: 'center'}}>
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to First T&E Entry"
                                            reactIcon={BiArrowToLeft}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                                            onClick={() => moveToFirstTneEntry}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Previous T&E Entry"
                                            reactIcon={BiLeftArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                                            onClick={() => moveToPreviousTneEntry()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Next T&E Entry"
                                            reactIcon={BiRightArrowAlt}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                                            onClick={() => moveToNextTneEntry()}
                                        />
                                        <Button
                                            style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                            text={''}
                                            title="Move to Last T&E Entry"
                                            reactIcon={BiArrowToRight}
                                            iconHoverColor="blue"
                                            iconStyle={{width: '3rem', height: '3rem', verticalAlign: 'center'}}
                                            onClick={moveToLastTneEntry}
                                        />
                                    </div>
                                    <FormRow>
                                        <RHFInputBox
                                            disabled={true}
                                            label="Landman"
                                            name={`landmanNumber`}
                                            defaultVal={getValues(`timeAndExpenseData[${!!selectedExpenseRowIndex ? selectedExpenseRowIndex : 0}].number`)}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label=""
                                            name={`landmanName`}
                                            defaultVal={getValues(`timeAndExpenseData[${!!selectedExpenseRowIndex ? selectedExpenseRowIndex : 0}].name`)}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '60%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Project Hours"
                                            name={`projectHours`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Days"
                                            name={`projectDays`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Period Hours"
                                            name={`periodHours`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Days"
                                            name={`periodDays`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Services"
                                            name={`services`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Expenses"
                                            name={`expenses`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Miles"
                                            name={`miles`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            disabled={true}
                                            label="Mileage"
                                            name={`mileage`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            readOnly={true}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                    </FormRow>
                                    <FormRow>
                                    <table className={'project-billing'}>
                                        <thead className={'project-billing'} style={{ textAlign: 'left' }}>
                                            <tr>
                                                <th style={{width: '6%'}}>Date</th>
                                                <th style={{width: '4%'}}>Day of Week</th>
                                                <th style={{width: '3%'}}>Hours</th>
                                                <th style={{width: '3%'}}>Days</th>
                                                <th style={{width: '10%'}}>Account</th>
                                                <th style={{width: '5%'}}>Expenses</th>
                                                <th style={{width: '50%'}}>Work Description</th>
                                            </tr>
                                        </thead>
                                        <tbody className={'project-billing'}>
                                        {landmanWorkDescriptions?.length > 0 && landmanWorkDescriptions?.map(
                                        (lwd: TsdiBillingWorkDescriptions, index: number) => {
                                            const billingAccountNumber = !!billingExpenses && selectedExpenseRowIndex !== undefined &&
                                            billingExpenses?.length > selectedExpenseRowIndex ? billingExpenses[selectedExpenseRowIndex]?.acctNo : 0;
                                            const billingAccountNumberString = !!tsdiAccounts ? tsdiAccounts.find((a) => a.code === billingAccountNumber)?.description : '';
                                            const wdDate = !!lwd?.date && lwd?.date instanceof Date ? lwd?.date?.toLocaleDateString() : new Date(lwd?.date).toLocaleDateString();
                                            return (
                                                <tr key={index}>
                                                    <td style={{width: '5%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={!!wdDate ? wdDate : ''}
                                                            disabled={true}
                                                            name={`date`}
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '4%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={lwd?.dayOftheWeek?.toString()}
                                                            disabled={true}
                                                            name={`dayOfWeek`}
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '3%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={lwd?.hours?.toString()}
                                                            disabled={true}
                                                            name={`hours`}
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '3%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={lwd?.days?.toString()}
                                                            disabled={true}
                                                            name={`days`}
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '13%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={billingAccountNumberString}
                                                            disabled={true}
                                                            name={`account`}
                                                            type="text"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '4%', verticalAlign: 'top', textAlign: 'left'}}>
                                                        <RHFInputBox
                                                            defaultVal={!!lwd?.expenses ? lwd.expenses?.toString() : '0'}
                                                            disabled={true}
                                                            name={`wdExpenses`}
                                                            type="number"
                                                            register={register}
                                                            errors={errors}
                                                            readOnly={true}
                                                            style={{ width: '100%' }}
                                                            bodyStyle={{ width: '100%', marginLeft: '.5rem' }}
                                                        />
                                                    </td>
                                                    <td style={{width: '50%'}}>
                                                        <RHFTextArea
                                                            defaultValue={lwd?.workDescription}
                                                            name={`workDescription`}
                                                            register={register}
                                                            style={{ width: '100%', height: 'auto', verticalAlign: 'top', textAlign: 'left', cursor: 'not-allowed', resize: 'none' }}
                                                        />
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                        </tbody>
                                        </table>
                                    </FormRow>
                                </CollapsibleSection>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <FindManagerDialog
                    dialogName={'Find Manager'}
                    hideDialog={hideDialog}
                    populateManagerList={getManagers}
                    managerList={managers}
                />
                <PersonnelSummaryDialog
                    timeAndExpenses={allBillingExpenses}
                    client={selectedClient}
                    projectId={projectIdForDialog}
                    dialogName={DialogList.PERSONNEL_SUMMARY}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                />
                <ExcelFileDialog
                    dialogName={DialogList.EXCEL_FILE}
                    hideDialog={hideDialog}
                />
                <RefreshDataDialog
                    dialogName={DialogList.REFRESH_BILLING_DATA}
                    handleRefreshData={(rType: number) => handleRefreshBillingData(rType)}
                    hideDialog={hideDialog}
                />
                <FlagNoteDialog 
                    dialogName={DialogList.FLAG_REASON_DIALOG} 
                    hideDialog={hideDialog}
                    handleConfirm={handleFlagBillingEntry}
                    type={!!noteMode ? 1 : 0}
                />
                <ViewLandmanExpensesDialog
                    dialogName={DialogList.VIEW_LM_EXPENSES}
                    hideDialog={hideDialog}
                    landmanExpenses={allLandmanExpenses}
                />
                <ViewFlagNotesDialog 
                    dialogName={DialogList.SHOW_FLAG_NOTES_DIALOG} 
                    hideDialog={hideDialog}
                    handleConfirm={hideDialog}
                    notes={flagAndCorrectionNotes && flagAndCorrectionNotes}
                    setRelaunch={setShowViewFlagNotes}
                    setNoteMode={setNoteMode}
                />
                <ReportOptionsDialog
                    payPeriods={payPeriods?.map(p => {
                        return {
                            label: (!!p.name ? `(${p.name})` : ''),
                            value: `${p.id}` };
                    })}
                    dialogName={DialogList.REPORT_OPTIONS}
                    hideDialog={hideDialog}
                    handleBillingReport={handleReport}
                    showDialog={showDialog}
                    reportTypes={[
                        { value: 'BillingSummary', label: 'Billing Summary' },
                        { value: 'BillingSummaryAPMPC', label: 'Billing Summary (APMPC)' },
                        { value: 'BillingSummaryByProspect', label: 'Billing Summary by Prospect' },
                        { value: 'BillingSummaryV1', label: 'Billing Summary (Legacy V1)' }
                    ]}
                    parentType={3}
                    offices={officeOptionValues}
                />
            </form>
        </div>
    );
};

export default ProjectBillingPage;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/ProjectBillingPage.tsx